import { gql } from '@apollo/client';
import { BizAoiProduceResult, PRODUCE_RESULT_FIELDS } from './produceResult';

/**
 * 更新已有 AOI 的几何 (编辑形状后保存)。
 */
export const UPDATE_BIZ_AOI_GEOMETRY = gql`
  mutation UpdateBizAoiGeometry($input: BizAoiGeometryUpdateInput!) {
    updateBizAoiGeometry(input: $input) {
${PRODUCE_RESULT_FIELDS}
    }
  }
`;

export interface BizAoiGeometryUpdateInput {
    aoiId: number;
    zipcode: string;
    geometryGeoJson: string;
}

export interface UpdateBizAoiGeometryResponse {
    updateBizAoiGeometry: BizAoiProduceResult;
}
